export default {
  surveyBuilder: {
    farmName: "Fattoria",
    farmerName: "Nome del coltivatore",
    scores: "Punteggio",
    clearSelection: "Cancella tutti gli utenti",
    addNewSurvey: "Aggiungi nuovo sondaggio",
    surveyTitle: "Titolo dell'indagine",
    surveyName: "Nome dell'indagine",
    surveyDescription: "Descrizione dell'indagine",
    describeSurvey: "Descrivere l'indagine",
    enableScheduling: "Abilitare la pianificazione",
    enableSchedulingInfo:
      "Capacità di impostare una data o un'ora specifica per la valutazione.",
    selectedDate: "Data selezionata",
    multiStepSurvey: "Indagine multi-livello",
    multiStepSurveyDetails:
      "Sulla base del numero di domande in una fase, tutte le domande nell'indagine saranno raggruppate e visualizzate nelle fasi.",
    multiStep: "Multi passo",
    noQuestionEachStep: "Numero di domande in ogni fase",
    surveyStatus: "Stato dell'indagine",
    surveyStatusDetails:
      "L'indagine può essere attivata solo dopo aver aggiunto delle domande. L'attuazione di un'indagine consentirà agli agricoltori di iniziare a presentare proposte.",
    selectUsers: "Seleziona gli utenti",
    selectUsersDetails:
      "Se l'utente selezionato è disattivato, l'indagine sarà disponibile per tutti gli utenti. Se si Attiva utenti selezionati è possibile selezionare più utenti nella fase successiva.",
    linkWithFarms: "Link con gli agriturismi",
    linkWithFarmsDetails:
      "Se abilitato l'indagine sarà collegata con le singole aziende agricole. Se un agricoltore ha più fattorie, ogni azienda avrà un proprio sondaggio.",
    enabled: "Abilitato",
    disabled: "Disabili",
    cancel: "Annulla",
    next: "Il prossimo",
    surveySettings: "Impostazioni dell'indagine",
    selectSurveyUsers: "Seleziona gli utenti di Survey",
    selectToProceed: "Si prega di selezionare utente(i) per procedere",
    searchUsers: "Utenti di ricerca",
    usersSelected: "Utenti Selezionati",
    conditional: "Condizione",
    autoConditional: "Auto condizionale",
    userName: "Nome utente",
    email: "Email",
    membershipType: "Tipo di iscrizione",
    membershipValidity: "Validità degli iscritti",
    membershipRemainingDays: "Numero di giorni rimanenti",
    membershipRole: "Ruolo membro",
    accountProgress: "Avanzamento",
    status: "Stato",
    active: "Attivo",
    deactivated: "Disattivato",
    continue: "Continua",
    questions: "Domande",
    questionInfo:
      "Il testo della domanda di valutazione che verrà presentata al rispondente.",
    responses: "Risposte",
    deleteSurvey: "Eliminare l'indagine",
    editSurvey: "Modifica dell'indagine",
    type: "Tipo",
    compulsory: "Obbligo",
    createSurvey: "Creare un sondaggio",
    surveyBuilder: "Costruttore di sondaggi",
    surveyList: "Elenco delle indagini",
    farm: "Fattoria",
    responseDate: "Data di risposta",
    viewSurvey: "Visualizza sondaggio",
    question: "Domanda",
    settings: "Impostazioni impostazioni",
    addQuestion: "Aggiungi una domanda",
    surveysSubmitted: "Indagini inserite",
    surveyDetail: "Dettaglio dell'indagine",
    conditionStatus: "Stato",
    conditionStatusDesc:
      "Gli utenti che soddisfano le condizioni diventeranno idonei all'indagine automaticamente.",
    endSurvey: "Indagine finale",
    publishSurvey: "Pubblica Indagine",
    copy: "Copia",
    view: "Vista",
    startDate: "Data di inizio",
    endDate: "Data di fine",
    chooseDate: "Scegli la data",
    select: "Seleziona",
    addSurveyQuestion: "Aggiungi domanda",
    editSurveyQuestion: "Modifica della domanda",
    questionScore: "Obiettivo",
    mandatory: "Mandato",
    yes: "Sì",
    no: "No",
    options: "Opzioni",
    typeHere: "Tipo qui",
    typeInfo:
      "Un menu a tendina per specificare il tipo di input richiesto per la domanda, come pulsante di opzione, casella di controllo o input di testo.",
    add: "Aggiungi",
    optionsHint:
      "Si prega di inserire per aggiungere una risposta o fare clic su Aggiungi",
    surveyProgress: "Indagine sui progressi",
    allResponses: "Riepilogo delle responsabilità",
    responseQuestion: "Risposte per domanda",
    dateSubmitted: "Data inserita",
    answer: "Risposte",
    totalScore: "Punteggio totale",
    score: "Punteggio",
    singleSelection: "Selezione singola",
    multipleSelection: "Selezione multipla",
    if: "Se",
    then: "allora",
    noResponse: "Nessuna risposta",
    noSurveyFound: "Nessun sondaggio trovato",
    createNewSurvey:
      'Si prega di creare sondaggio utilizzando il pulsante "Create Survey" sopra',
    cannotPublish: "Non è possibile pubblicare un sondaggio disabilitato!",
    deleteSurveyWarn:
      "Sei sicuro di voler eliminare il sondaggio. Se cancellate tutte le domande e le sottomissioni del sondaggio verranno eliminate in modo permanente.",
    noQuestionFound: "Nessun problema trovato",
    createQuestion:
      'Si prega di aggiungere prima domanda utilizzando il pulsante "ADD QUESTIONS" sopra',
    deleteQuestion: "Sei sicuro di voler eliminare la domanda?",
    applyChanges: "Come si desidera applicare queste modifiche?",
    editFutureSurveys: "FUTTURE EDIT SOLO",
    editLiveSurveyOnly: "EDIT LIVE SURVELY",
    surveyIsLive:
      "Si prega di notare che l'indagine è attualmente in diretta, e la modifica di una domanda in questo momento può influenzare le presentazioni precedenti. Per evitare qualsiasi problema, si può considerare la creazione di una copia dell'indagine al fine di apportare modifiche alle domande.",
    clickToCopy: "Clicca qui per creare copia dell'indagine",
    applyChangesNow: "PRESTAZIONI",
    copySurvey: "Copia Indagine",
    changeCopySurveyName:
      "È possibile modificare il nome della versione di indagine copiata.",
    textField: "Campo di testo",
    textArea: "Area di testo",
    textFieldNumeric: "Campo di testo Numerico",
    radioButton: "Pulsante radio",
    checkBoxes: "Caselle di controllo",
    fileAttachment: "Allegato file",
    digitalSignature: "Firma digitale",
    gpsLocation: "Posizione GPS",
    dynamicFarmer: "Farmer dinamico",
    dynamicGeofence: "Geofenza dinamica",
    dynamicCrop: "Crocco dinamico",
    dynamicEquipment: "Attrezzature dinamiche",
    downloadSurvey: "Scarica l'indagine",
    downloadQuestion: "Scarica solo domande",
    downloadResponse: "Scarica tutte le risposte",
    chooseFileFormat: "Scegliere Formato file",
    surveyTitleLength:
      "Il titolo dell'indagine dovrebbe essere inferiore a 100 caratteri",
    selectAllFiltered: "Selezionare tutti i filtri",
    surveyDownloads: "Indagine Download",
  },
};
